import Vue from "vue";

import _ from "lodash";
import cf from "@/helpers/conf";
import fn from "@/helpers/func";
import VueMq from "vue-mq";
import Intersect from "vue-intersect";
import VueAwesomeSwiper from "vue-awesome-swiper";
import Swiper, {
  Navigation,
  Pagination,
  Scrollbar,
  EffectFade,
  Autoplay
} from "swiper";
import "swiper/swiper-bundle.css";
import VueCookies from "vue-cookies";
import SlideUpDown from "vue-slide-up-down";
import PortalVue from "portal-vue";
import VueTyperPlugin from "vue-typer";
import VueMeta from "vue-meta";

Vue.use(VueMeta);
Vue.component("slide-up-down", SlideUpDown);
Vue.use(require("vue-moment"), {
  moment
});
var moment = require("moment");

Vue.prototype.$fn = fn;
Vue.prototype.$cf = cf;

Vue.use(_);
Vue.prototype._ = _;
Vue.use(VueAwesomeSwiper);
Vue.use(Intersect);
Vue.use(VueCookies);
Vue.use(PortalVue);
Vue.use(VueTyperPlugin);

Swiper.use([Navigation, Pagination, Scrollbar, EffectFade, Autoplay]);
Vue.use(VueMq, {
  breakpoints: {
    phone: 767,
    tablet: 1025,
    md: 1365,
    lg: 1599
  },
  defaultBreakpoint: "sm" // customize this for SSR
});
Vue.component("slide-up-down", SlideUpDown);
